import React, { useState, useEffect } from "react";
import Select from "react-select";
import { DatePicker } from "rsuite";

import PageTitle from "../../layouts/PageTitle";
import { useNavigate, useLocation, Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  createAndUpdatePlayer,
  getBattingType,
  getBowlingType,
  getGender,
  getPackageType,
  uploadPlayerForm,
  uploadPlayerImage,
} from "../../../services/academicService";
import ImagePreviewModal from "../../components/ImagePreviewModal";
import { publicPlayerRegistration } from "../../../services/publicService";
import { formatDate } from "../../../utils/helperFunction";

const PlayerInquiry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const editPlayer = location.state?.user || null;
  const [battingData, setBattingData] = useState([]);
  const [bowlingData, setBowlingData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedBatting, setSelectedBatting] = useState([]);
  const [selectedBowling, setSelectedBowling] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [uploadedImageFiles, setUploadedImageFiles] = useState(null);
  const [uploadedFormFiles, setUploadedFormFiles] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileName, setPreviewFileName] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    dob: null,
    sex: "",
    address: "",
    mobileNumber: "",
    email: "",
    schoolName: "",
    wicketKeeping: "",
    clubMember: "",
    parentName: "",
    joiningDate: null,
    amountDeposited: "",
    selectedPackage: "",
    receiptNo: "",
  });

  useEffect(() => {
    if (editPlayer) {
      setFormData({
        name: editPlayer.name || "",
        dob: editPlayer.dob ? new Date(editPlayer.dob) : null,
        address: editPlayer.address || "",
        mobileNumber: editPlayer.phone || "",
        email: editPlayer.email || "",
        schoolName: editPlayer.schoolName || "",
        batting: editPlayer.batting || "",
        wicketKeeping: editPlayer.wicketKeeper ? "Yes" : "No",
        clubMember: editPlayer.memberOfOtherClub ? "Yes" : "No",
        parentName: editPlayer.parentName || "",
        // joiningDate: editPlayer.dateOfJoining
        //   ? new Date(editPlayer.dateOfJoining)
        //   : null,
        // amountDeposited: editPlayer.amountDeposited || "",
        // receiptNo: editPlayer.receiptNumber || "",
      });
      setSelectedBatting(
        editPlayer.batting && Array.isArray(editPlayer.batting)
          ? editPlayer.batting.map((item) => ({ value: item, label: item }))
          : []
      );
      setSelectedBowling(
        editPlayer.bowling && Array.isArray(editPlayer.bowling)
          ? editPlayer.bowling.map((item) => ({ value: item, label: item }))
          : []
      );
      setSelectedGender(
        editPlayer.sex
          ? {
              value: editPlayer.sex,
              label: editPlayer.sex,
            }
          : null
      );
      setSelectedPackage(
        editPlayer.packageType
          ? {
              value: editPlayer.packageType,
              label: editPlayer.packageType,
            }
          : null
      );
      // setUploadedFormFiles(editPlayer.playerForm || null);
      // setUploadedImageFiles(editPlayer.playerImage || null);
    }
  }, [editPlayer]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSelectChange = (name, option) => {
    setFormData({ ...formData, [name]: option?.value || "" });
    setErrors({ ...errors, [name]: "" });
  };

  const handleDateChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleImageFileChange = async (e) => {
    try {
      const file = e.target.files[0]; //single file
      if (!file) return;

      //Upload to API
      const res = await uploadPlayerImage(file);

      //REPLACE instead of append
      setUploadedImageFiles(res);
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const handleFormFileChange = async (e) => {
    try {
      const file = e.target.files[0]; //single file
      if (!file) return;

      //Upload to API
      const res = await uploadPlayerForm(file);

      //REPLACE instead of append
      setUploadedFormFiles(res);
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.dob) newErrors.dob = "Date of Birth is required";
    if (!selectedGender) newErrors.gender = "Gender is required";
    if (!selectedPackage) newErrors.package = "Package is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.email)
    ) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile Number is required";
    }
    if (!formData.address.trim()) newErrors.address = "Address is required";

    // Proficiency
    if (selectedBatting.length === 0)
      newErrors.batting = "Batting style is required";
    if (selectedBowling.length === 0)
      newErrors.bowling = "Bowling type is required";
    if (!formData.wicketKeeping)
      newErrors.wicketKeeping = "Wicket Keeping selection is required";
    if (!formData.clubMember)
      newErrors.clubMember = "Please select if member of other club";
    if (!formData.parentName.trim())
      newErrors.parentName = "Parent Name is required";

    // // Membership
    // if (!formData.joiningDate)
    //   newErrors.joiningDate = "Date of Joining is required";
    // if (!formData.amountDeposited)
    //   newErrors.amountDeposited = "Amount Deposited is required";
    // if (!formData.receiptNo.trim())
    //   newErrors.receiptNo = "Receipt Number is required";
    console.log("validation errors", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e, actionType) => {
    e.preventDefault();

    if (!validate()) return;
    setLoading(true);

    const payload = {
      id: editPlayer?.id || undefined,
      name: formData.name,
      dob: formData.dob ? formatDate(formData.dob) : null,
      sex: selectedGender?.value || "",
      address: formData.address,
      phone: formData.mobileNumber,
      email: formData.email,
      batting: selectedBatting ? selectedBatting.map((item) => item.value) : [],
      bowling: selectedBowling ? selectedBowling.map((item) => item.value) : [],
      wicketKeeper: formData.wicketKeeping === "Yes",
      memberOfOtherClub: formData.clubMember === "Yes",
      parentName: formData.parentName,
      packageType: selectedPackage?.value || "",
      // dateOfJoining: formData.joiningDate
      //   ? formatDate(formData.joiningDate)
      //   : null,
      // amountDeposited: formData.amountDeposited
      //   ? parseInt(formData.amountDeposited)
      //   : 0,
      // receiptNumber: formData.receiptNo,
      // playerImage: uploadedImageFiles,
      // playerForm: uploadedFormFiles,
      tenantId: id,
      statusType: actionType,
    };

    try {
      const res = await publicPlayerRegistration(payload);

      if (res) {
        toast.success(
          editPlayer
            ? "Player enquiry updated successfully!"
            : "Player enquiry submitted successfully!",
          { position: "top-right", autoClose: 1000 }
        );
        setIsSubmitted(true);
        handleReset();
      }

      // navigate("/admin/all-players");
      // window.location.reload();
    } catch (error) {
      toast.error("An error occurred while submitting the form.", {
        position: "top-right",
        autoClose: 2000,
      });

      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBattingData();
  }, []);

  async function fetchBattingData() {
    try {
      const res = await getBattingType();
      setBattingData(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  useEffect(() => {
    fetchBowlingData();
  }, []);

  async function fetchBowlingData() {
    try {
      const res = await getBowlingType();
      setBowlingData(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  useEffect(() => {
    fetchGender();
  }, []);

  async function fetchGender() {
    try {
      const res = await getGender();
      setGenderData(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  useEffect(() => {
    fetchPackage();
  }, []);

  async function fetchPackage() {
    try {
      const res = await getPackageType();
      setPackageData(res);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  }

  async function handleReset() {
    setFormData({
      name: "",
      dob: null,
      sex: null,
      address: "",
      mobileNumber: "",
      email: "",
      batting: [],
      bowling: [],
      wicketKeeping: "No",
      clubMember: "No",
      parentName: "",
      packageType: null,
      joiningDate: null,
      amountDeposited: "",
      receiptNo: "",
    });
    setSelectedGender(null);
    setSelectedBatting([]);
    setSelectedBowling([]);
    setSelectedPackage(null);
    setUploadedImageFiles(null);
    setUploadedFormFiles(null);
    setErrors({});
  }

  return (
    <>
      <PageTitle activeMenu={"Add Players"} motherMenu={"Players"} />
      {isSubmitted ? (
        <div className="text-center  d-flex flex-column justify-content-center align-items-center">
          <div className="mb-4">
            <i
              className="fa fa-check-circle text-success"
              style={{ fontSize: "80px" }}
            ></i>
          </div>
          <h3 className="text-success mb-3">Player Enquiry Submitted!</h3>
          <p className="mb-4">
            Your player enquiry has been submitted successfully.
          </p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setIsSubmitted(false)}
          >
            Add Another Enquiry
          </button>
        </div>
      ) : (
        <div className="row">
          <div className="col-xl-12 col-xxl-12 col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">
                  Whitefield Cricket Academy Player Enquiry
                </h5>
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    {/* Name of the Student */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="name">
                          Name of the player{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          id="name"
                          placeholder="Enter Full Name"
                          type="text"
                          name="name"
                          className={`form-control ${
                            errors.name ? "is-invalid" : ""
                          }`}
                          value={formData.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="text-danger m-lg-2">
                            {errors.name}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Date of Birth */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="dob">
                          Date of Birth <span className="text-danger">*</span>
                        </label>
                        <div className="input-hasicon mb-xl-0 mb-3">
                          <DatePicker
                            placeholder="Select Date of Birth"
                            className="picker-suit"
                            value={formData.dob}
                            onChange={(val) => handleDateChange("dob", val)}
                          />
                          <div className="icon">
                            <i className="far fa-calendar" />
                          </div>
                        </div>
                        {errors.dob && (
                          <div className="text-danger m-lg-2">{errors.dob}</div>
                        )}
                      </div>
                    </div>

                    {/* Sex */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label">
                          Gender <span className="text-danger">*</span>
                        </label>
                        <Select
                          isSearchable={false}
                          options={genderData}
                          placeholder="Select Gender"
                          className="custom-react-select"
                          value={selectedGender}
                          onChange={setSelectedGender}
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.gender
                                ? "#FF1616"
                                : base.borderColor,
                              boxShadow: errors.gender
                                ? "0 0 0 1px #FF1616"
                                : base.boxShadow,
                              "&:hover": {
                                borderColor: errors.gender
                                  ? "#FF1616"
                                  : base.borderColor,
                              },
                            }),
                          }}
                        />
                        {errors.gender && (
                          <div className="text-danger m-lg-2">
                            {errors.gender}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Package */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label">
                          Package <span className="text-danger">*</span>
                        </label>
                        <Select
                          isSearchable={false}
                          options={packageData?.map((pkg) => ({
                            value: pkg.key,
                            label: pkg.value,
                          }))}
                          placeholder="Select Package"
                          className="custom-react-select"
                          value={selectedPackage}
                          onChange={setSelectedPackage}
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.package
                                ? "#FF1616"
                                : base.borderColor,
                              boxShadow: errors.package
                                ? "0 0 0 1px #FF1616"
                                : base.boxShadow,
                              "&:hover": {
                                borderColor: errors.package
                                  ? "#FF1616"
                                  : base.borderColor,
                              },
                            }),
                          }}
                        />
                        {errors.package && (
                          <div className="text-danger m-lg-2">
                            {errors.package}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="email">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          id="email"
                          name="email"
                          placeholder="Enter Email"
                          type="email"
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="text-danger m-lg-2">
                            {errors.email}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Mobile Number */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="mobileNumber">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          id="mobileNumber"
                          name="mobileNumber"
                          placeholder="Enter Mobile Number"
                          type="number"
                          className={`form-control ${
                            errors.mobileNumber ? "is-invalid" : ""
                          }`}
                          value={formData.mobileNumber}
                          onChange={handleChange}
                        />
                        {errors.mobileNumber && (
                          <div className="text-danger m-lg-2">
                            {errors.mobileNumber}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Address */}
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="address">
                          Address <span className="text-danger">*</span>
                        </label>
                        <textarea
                          id="address"
                          name="address"
                          placeholder="Enter Address"
                          className={`form-control ${
                            errors.address ? "is-invalid" : ""
                          }`}
                          rows="3"
                          value={formData.address}
                          onChange={handleChange}
                        />
                        {errors.address && (
                          <div className="text-danger m-lg-2">
                            {errors.address}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Proficiency Section */}
                    <div className="col-lg-12">
                      <h6 className="mt-3">Proficiency</h6>
                    </div>

                    {/* Batting */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label">
                          Batting <span className="text-danger">*</span>
                        </label>
                        <Select
                          isSearchable={false}
                          isMulti
                          options={battingData}
                          placeholder="Select Batting Style"
                          className="custom-react-select"
                          value={selectedBatting}
                          onChange={setSelectedBatting}
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.batting
                                ? "#FF1616"
                                : base.borderColor,
                              boxShadow: errors.batting
                                ? "0 0 0 1px #FF1616"
                                : base.boxShadow,
                              "&:hover": {
                                borderColor: errors.batting
                                  ? "#FF1616"
                                  : base.borderColor,
                              },
                            }),
                          }}
                        />
                        {errors.batting && (
                          <div className="text-danger m-lg-2">
                            {errors.batting}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Bowling */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label">
                          Bowling <span className="text-danger">*</span>
                        </label>
                        <Select
                          isSearchable={false}
                          isMulti
                          options={bowlingData}
                          placeholder="Select Bowling Type"
                          className="custom-react-select"
                          value={selectedBowling}
                          onChange={setSelectedBowling}
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.bowling
                                ? "#FF1616"
                                : base.borderColor,
                              boxShadow: errors.bowling
                                ? "0 0 0 1px #FF1616"
                                : base.boxShadow,
                              "&:hover": {
                                borderColor: errors.bowling
                                  ? "#FF1616"
                                  : base.borderColor,
                              },
                            }),
                          }}
                        />
                        {errors.bowling && (
                          <div className="text-danger m-lg-2">
                            {errors.bowling}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Wicket Keeping */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label">
                          Wicket Keeping <span className="text-danger">*</span>
                        </label>
                        <Select
                          isSearchable={false}
                          options={[
                            { value: "Yes", label: "Yes" },
                            { value: "No", label: "No" },
                          ]}
                          placeholder="Do you keep wickets?"
                          className="custom-react-select"
                          value={
                            formData.wicketKeeping
                              ? {
                                  value: formData.wicketKeeping,
                                  label: formData.wicketKeeping,
                                }
                              : null
                          }
                          onChange={(opt) =>
                            handleSelectChange("wicketKeeping", opt)
                          }
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.wicketKeeping
                                ? "#FF1616"
                                : base.borderColor,
                              boxShadow: errors.wicketKeeping
                                ? "0 0 0 1px #FF1616"
                                : base.boxShadow,
                              "&:hover": {
                                borderColor: errors.wicketKeeping
                                  ? "#FF1616"
                                  : base.borderColor,
                              },
                            }),
                          }}
                        />
                        {errors.wicketKeeping && (
                          <div className="text-danger m-lg-2">
                            {errors.wicketKeeping}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Member of any club */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label">
                          Member of Any Other Club{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          isSearchable={false}
                          options={[
                            { value: "Yes", label: "Yes" },
                            { value: "No", label: "No" },
                          ]}
                          placeholder="Select"
                          className="custom-react-select"
                          value={
                            formData.clubMember
                              ? {
                                  value: formData.clubMember,
                                  label: formData.clubMember,
                                }
                              : null
                          }
                          onChange={(opt) =>
                            handleSelectChange("clubMember", opt)
                          }
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.clubMember
                                ? "#FF1616"
                                : base.borderColor,
                              boxShadow: errors.clubMember
                                ? "0 0 0 1px #FF1616"
                                : base.boxShadow,
                              "&:hover": {
                                borderColor: errors.clubMember
                                  ? "#FF1616"
                                  : base.borderColor,
                              },
                            }),
                          }}
                        />
                        {errors.clubMember && (
                          <div className="text-danger m-lg-2">
                            {errors.clubMember}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Parent Name */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="parentName">
                          Parent Name <span className="text-danger">*</span>
                        </label>
                        <input
                          id="parentName"
                          name="parentName"
                          placeholder="Enter Parent Name"
                          type="text"
                          className={`form-control ${
                            errors.parentName ? "is-invalid" : ""
                          }`}
                          value={formData.parentName}
                          onChange={handleChange}
                        />
                        {errors.parentName && (
                          <div className="text-danger m-lg-2">
                            {errors.parentName}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Parent Signature Upload */}
                    <div className="col-sm-6">
                      <div className="form-group fallback w-100">
                        <label className="form-label">Player Image </label>
                        <input
                          id="parentSignature"
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={handleImageFileChange}
                        />
                      </div>
                    </div>

                    {/* Student Signature Upload */}
                    {/* <div className="col-sm-6">
                    <div className="form-group fallback w-100">
                      <label className="form-label">Player Form</label>
                      <input
                        id="studentSignature"
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFormFileChange}
                      />
                    </div>
                  </div> */}

                    {uploadedImageFiles && (
                      <div className="col-sm-12">
                        <h6>Image File</h6>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                            {/* File Name on the Left */}
                            <div
                              style={{
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {uploadedImageFiles?.fileName}
                            </div>

                            {/* Action Buttons on the Right */}
                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                title="View"
                                onClick={() => {
                                  setPreviewFileName(
                                    uploadedImageFiles.fileName
                                  );
                                  setPreviewModal(true);
                                }}
                              >
                                <i className="fa fa-eye" />
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                title="Delete"
                                onClick={() => setUploadedImageFiles(null)}
                              >
                                <i className="fa fa-trash" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Submit */}
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      {/* <button
                        type="button"
                        onClick={handleSubmit}
                        className="btn btn-primary me-1"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button> */}
                      <button
                        type="button"
                        onClick={(e) => handleSubmit(e, "Registration")}
                        className="btn btn-success me-2"
                        disabled={loading}
                      >
                        {loading ? "Processing..." : "Register"}
                      </button>

                      <button
                        type="button"
                        onClick={(e) => handleSubmit(e, "Enquiry")}
                        className="btn btn-warning me-2"
                        disabled={loading}
                      >
                        {loading ? "Processing..." : "Only Enquiry"}
                      </button>
                      <button
                        type="button"
                        onClick={handleReset}
                        // to="/admin/all-players"
                        className="btn btn-danger light"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <ImagePreviewModal
        show={previewModal}
        onClose={() => setPreviewModal(false)}
        fileName={previewFileName}
      />
    </>
  );
};

export default PlayerInquiry;
